import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {Image} from '@app/components/Image';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';

export const ImproveYourFlow: FunctionComponent = () => {
	const {t} = useTranslation();
	return (
		<LandingIllustrationSection
			description={
				<>
					<LandingHeading as="h2">
						{t(
							'flowlandingpage_title_improveflowbyshowingwhatyoulike_standalone-web',
							{ns: 'flow'},
						)}
					</LandingHeading>
					<LandingParagraph>
						{t(
							'flowlandingpage_text_improveflowbyshowingwhatyoulike_standalone-web',
							{ns: 'flow'},
						)}
					</LandingParagraph>
				</>
			}
			image={
				<Image
					src="8b5b9c2e0e80d55dfe5d082a0102999c.png"
					aspectRatio="2048/622"
					alt={t(
						'flowlandingpage_title_improveflowbyshowingwhatyoulike_standalone-web',
						{ns: 'flow'},
					)}
				/>
			}
		/>
	);
};
